import { CroppedViz, GiantViz, XyInfo } from "./terrainMain";

export const cropped = async (viz: CroppedViz | GiantViz, xyInfo: XyInfo) => {
  if (!xyInfo.lowest || !xyInfo.highest) return;
  const {
    canvasNS,
    canvasDEM,
    type,
    tileAmountX,
    tileAmountY,
    croppedCanvasNS,
    croppedCanvasDEM,
    croppedCtxNS,
    croppedCtxDem,
    croppedBounds,
  } = viz;
  const { lowest, highest } = xyInfo;

  // Draw the image to its cropped canvas
  const widthPixels = (highest[0] - lowest[0]) * 256;
  const heightPixels = (highest[1] - lowest[1]) * 256;
  croppedCanvasNS.width = widthPixels;
  croppedCanvasNS.height = heightPixels;
  croppedCanvasDEM.width = widthPixels;
  croppedCanvasDEM.height = heightPixels;

  const drawCanvas = (
    target: OffscreenCanvasRenderingContext2D,
    origin: OffscreenCanvas,
    x: number,
    y: number
  ) => {
    target.drawImage(
      origin,
      x * 256,
      y * 256,
      widthPixels,
      heightPixels,
      0,
      0,
      widthPixels,
      heightPixels
    );
  };

  const [lowX, lowY] = lowest;
  if (type === "giant") {
    const halfTileAmountX = Math.floor(tileAmountX / 2);
    const halfTileAmountY = Math.floor(tileAmountY / 2);
    const lowXFromHalf = lowX - halfTileAmountX;
    const lowYFromHalf = lowY - halfTileAmountY;

    // Left top
    if (lowX < halfTileAmountX && lowY < halfTileAmountY) {
      drawCanvas(croppedCtxNS, canvasNS[0], lowX, lowY);
      drawCanvas(croppedCtxDem, canvasDEM[0], lowX, lowY);
    }
    // Right top
    if (highest[0] > halfTileAmountX && lowY < halfTileAmountY) {
      drawCanvas(croppedCtxNS, canvasNS[1], lowXFromHalf, lowY);
      drawCanvas(croppedCtxDem, canvasDEM[1], lowXFromHalf, lowY);
    }
    // Left bottom
    if (lowX < halfTileAmountX && highest[1] > halfTileAmountY) {
      drawCanvas(croppedCtxNS, canvasNS[2], lowX, lowYFromHalf);
      drawCanvas(croppedCtxDem, canvasDEM[2], lowX, lowYFromHalf);
    }
    // Right bottom
    if (highest[0] > halfTileAmountX && highest[1] > halfTileAmountY) {
      drawCanvas(croppedCtxNS, canvasNS[3], lowXFromHalf, lowYFromHalf);
      drawCanvas(croppedCtxDem, canvasDEM[3], lowXFromHalf, lowYFromHalf);
    }
  } else {
    // 1 Canvas
    drawCanvas(croppedCtxNS, canvasNS, lowX, lowY);
    drawCanvas(croppedCtxDem, canvasDEM, lowX, lowY);
  }

  return {
    imageNS: croppedCanvasNS,
    imageDEM: croppedCanvasDEM,
    newBounds: croppedBounds,
  };
};
